import { render } from "./Overlijdensberichten.vue?vue&type=template&id=99f9fca6"
import script from "./Overlijdensberichten.vue?vue&type=script&lang=js"
export * from "./Overlijdensberichten.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__